import React from "react";
import HeroSection from "./HeroSection";
import StatsSection from "./StatsSection.jsx";
import JobOffersSection from "./JobOffersSection.jsx";
import CompaniesSection from "./CompaniesSection.jsx";
import GenerateCVSection from "./GenerateCVSection.jsx";
import WhyChooseUsSection from "./WhyChooseUsSection.jsx";
import DashboardShowcase from "./DashboardShowcase.jsx";
import DualCTASection from "./DualCTASection.jsx";
import TestimonialsSection from "./TestimonialsSection.jsx";
import BlogSection from "bundles/common/components/BlogSection";
import HowItWorks from "bundles/LandingPageRecruiter/components/landing_page/HowItWorks";
import ContactSection from "bundles/LandingPageRecruiter/components/landing_page/ContactSection";

const LandingPage = () => {
  return (
    <>
      <HeroSection />
      <StatsSection />
      <JobOffersSection />
      <HowItWorks type="candidate" />
      <CompaniesSection />
      <GenerateCVSection />
      <BlogSection type="candidate" />
      <WhyChooseUsSection />
      <DashboardShowcase />
      <DualCTASection />
      <TestimonialsSection />
      <ContactSection type="candidate" />
    </>
  );
};

export default LandingPage;
